import styled from 'vue-styled-components';

import { FLEX_CENTER, GRAY } from '@/styles/common.styled';

export const ComponentWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-radius: 2px;
    background-color: ${GRAY(10)};
    border: 1px solid ${GRAY(20)};

    .title {
        ${FLEX_CENTER}
        padding: 0;
        margin: 0;

        svg.icon {
            width: 16px;
            height: 16px;
            margin-right: 8px;
        }

        h3 {
            flex: 1;
            color: ${GRAY(100)};
            font-size: 14px;
            font-weight: 500;
        }
    }

    svg.icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
`;

export const MenuWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const MenuItem = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    justify-content: space-between;
    border: 1px solid ${GRAY(25)};
    height: fit-content;

    .title {
        display: flex;
        align-items: center;
        margin: 0;
        padding: 0;
        flex-shrink: 0;
        color: ${GRAY(100)};
        font-size: 14px;
        font-weight: 500;
        gap: 6px;
    }

    &:not(:first-child) {
        border-top: none;
    }
`;

export const SelectedBoxWrapper = styled.div`
    width: 248px;
    position: relative;
`;

export const DropdownBoxWrapper = styled.div`
    width: 100%;
    position: absolute;
    z-index: 1;
    margin-top: 3px;
`;
